import { render, staticRenderFns } from "./day06.vue?vue&type=template&id=2afbb03b&scoped=true&"
import script from "./day06.vue?vue&type=script&lang=js&"
export * from "./day06.vue?vue&type=script&lang=js&"
import style0 from "./day06.vue?vue&type=style&index=0&id=2afbb03b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbb03b",
  null
  
)

export default component.exports